<template>
  <el-table-column
    prop="receipt_number"
    sortable="custom"
    label="Bizonylatszám"
    show-overflow-tooltip
    min-width="200"
    fixed
  >
    <template slot-scope="scope">
      <div>
        {{ scope.row.receipt_number }}
        <!--<receipt-link-->
        <!--v-if="scope.row.receipt_number"-->
        <!--:id="scope.row.id"-->
        <!--:label="scope.row.receipt_number"-->
        <!--type="representativeSale"-->
        <!--/>-->
      </div>
      <el-tooltip
        v-if="scope.row.type === 'cancel'"
        class="item"
        effect="dark"
        :content="`Ez a eladás a következőt sztornózza: ${scope.row.cancelled_representative_sale_receipt_number}`"
        placement="right"
      >
        <el-tag
          size="mini"
          type="danger"
          style="margin-top: 5px; cursor: help;"
        >
          Sztornó
        </el-tag>
      </el-tooltip>
      <el-tooltip
        v-if="scope.row.type === 'sale' && scope.row.status === 'cancelled'"
        class="item"
        effect="dark"
        :content="`Ezt a eladást a következő sztornózza: ${scope.row.cancel_representative_sale_receipt_number}`"
        placement="right"
      >
        <el-tag
          size="mini"
          type="danger"
          style="margin-top: 5px;"
        >
          Sztornózva
        </el-tag>
      </el-tooltip>
    </template>
  </el-table-column>
</template>

<script>
  import ReceiptLink from '../../../utils/ReceiptLink';

  export default {
    components: {
      ReceiptLink,
    },
    propName: 'receipt_number',
  };
</script>
